import { render, staticRenderFns } from "./SearchMenuOptional.vue?vue&type=template&id=146ccff6"
import script from "./SearchMenuOptional.vue?vue&type=script&lang=js"
export * from "./SearchMenuOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports